import { observer } from 'mobx-react';
import * as React from 'react';
import { autoinject, inject } from '../Utils/AutoInject';
import { CommonAppStore } from '../Utils/CommonAppStore';

export interface IMainContainerProps {
    mainCointainerRef?(r: HTMLDivElement | null): void;
    onScroll?(): void;
}

@autoinject
@observer
export class MainContainer extends React.Component<IMainContainerProps> {
    public render() {
        const { mainCointainerRef, children } = this.props;

        return (
            <div
                className="main-container"
                ref={mainCointainerRef}
                style={{ height: `calc(100% - ${(this.commonAppStore.headerHeight ?? 0) + 1}px)` }}
                onScroll={this.props.onScroll}
            >
                {children}
            </div>
        );
    }

    @inject
    private readonly commonAppStore!: CommonAppStore;
}
